<template>
  <div id="app">
    <keep-alive v-if="$route.meta.keepAlive">
      <router-view></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
import { service, API } from './net/http';
import jsLoader from './utils/jsLoader';
import qs from 'qs';
const notProcessUrls = [API.orderSave.url, API.authForget.url, API.userUserInfo.url];
export default {
  name: 'App',
  mounted() {
    this.initConfig();
    jsLoader('https://static.zdassets.com/ekr/snippet.js?key=3f523479-453b-4724-a449-3c6b41dfc9bb', 'ze-snippet').then(
      async () => {
        window.zE('messenger:set', 'locale', 'en-us');
      },
    );
  },
  methods: {
    initConfig() {
      //TIPS:因为这里有拦截器，请注意，http访问在这个函数之后会被拦截处理response
      this.initNetErrorHandler();
      this.$store.dispatch('app/checkAppConfig');
    },
    initNetErrorHandler() {
      let self = this;
      service.interceptors.response.use(
        function (response) {
          if (response.status === 401 || response.status === 403 || response.status === 406) {
            self.$store.commit('app/logout');
            self.processAuth(response.config.url);
            return {
              success: false,
              message: response.statusText,
              response: response,
            };
          }
          if (response.status === 200) {
            return response.data;
          }
          return response;
        },
        function (error) {
          self.$Message.error({
            content: error.message,
            duration: 3,
          });
          return Promise.reject(error);
        },
      );
    },
    processAuth(url = '') {
      let findex = notProcessUrls.findIndex(shortUrl => {
        return url.indexOf(shortUrl) > -1;
      });
      if (url.length > 0 && findex < 0) {
        this.$nextTick(() => {
          let { path, query, name } = this.$route;
          if (name !== 'login') {
            this.$router.push({
              path: '/login',
              query: {
                backurl: `${path}?${qs.stringify(query)}`,
              },
            });
          }
        });
      }
    },
  },
};
</script>

<style lang="less">
@import './assets/fonts/font.less';
@import './assets/css/main.less';
html,
body,
#app {
  .font-light;
  height: 100%;
}
body {
  min-width: 1200px;
}
input {
  background: none;
  outline: none;
  border: none;
}
input:focus {
  border: none;
}
.btn {
  cursor: pointer;
}
.bar-content {
  padding-top: 86px;
}
.center {
  width: 1148px;
  margin: 0px auto;
}
</style>
